// @ts-check
import Debug from 'debug'
import {clone, filter, find, findIndex, forEach, groupBy, head, isEmpty, keys, mapObjIndexed, pipe, pluck, propEq, reduce, sort, values} from 'ramda'
import moment from 'moment-timezone'
import manageReqsController from './manageReqs.ctrl'
import manageReqs from './manageReqs.html'
import { updateWageModalController } from './updateWageModal.controller.js'
import updateWageModal from './updateWageModal.html'
import manageDetailsController from './manageDetails.ctrl'
import manageDetails from './manageDetails.html'
import groupMessageController from '../workforce/message/groupMessage.ctrl.js'
import groupMessage from '../workforce/message/groupMessage.html'
import rosterOptions from './rosterOptions.html'
import reminderEmail from './reminderEmail.html'
import reminderEmailCtrl from './reminderEmail.ctrl'
import profileTemplate from '../workforce/worker/worker.html'
import { WorkerController } from '../workforce/worker/worker.controller'
import addWorkerCtrl from '../job/addWorker/addWorker.ctrl'
import addWorkerTpl from '../job/addWorker/addWorker.html'
import editScheduleCtrl from '../roster/edit-schedule/edit-schedule.ctrl'
import editScheduleTpl from '../roster/edit-schedule/edit-schedule.html'
import { addDays, differenceInCalendarDays, endOfWeek, isSunday } from 'date-fns'
import jobOverlapModal from "./job-overlap-modal/job-overlap-modal.html";
import {JobOverlapModalController} from "./job-overlap-modal/job-overlap-modal.ctrl";

const debug = Debug('app:manage-jobs:controller')
const DEFAULT_REGIONS_OPTION = 'All regions';
const ROSTER_STATUS = { ASSIGNED: 0, WAITLIST: 1, REMOVED: 8 }
class ManageJobsController {
  /* @ngInject*/
  constructor (Auth, ManageJobs, ReferenceService, ToastService, Jobs, $scope, $templateCache, $mdToast, Message, Companies, Users, $stateParams, jobTypes, $mdDialog, $q, $interval, $mdSidenav, admins, skills, $mdExpansionPanel, $state) {
    this.ManageJobs = ManageJobs
    this.ToastService = ToastService
    this.Jobs = Jobs
    this.Users = Users
    this.Message = Message
    this.Companies = Companies
    this.$mdDialog = $mdDialog
    this.$mdExpansionPanel = $mdExpansionPanel
    this.$q = $q
    this.$interval = $interval
    this.$mdSidenav = $mdSidenav
    this.$templateCache = $templateCache
    this.$mdToast = $mdToast
    this.$scope = $scope
    this.skills = skills
    this.$state = $state

    // internal tool so company id is 2
    this.company = { id: 2 }
    if ($stateParams) {
      this.region = $stateParams.region || null
      this.cancelledJobs = $stateParams.cancelled || false
      this.acctManager = $stateParams.manager || null
      this.openJobId = $stateParams.jobId || null
    }
    if ($stateParams.date) {
      this.dateCutoff = moment($stateParams.date).startOf(this.dateViewToggle).format()
      this.futureDateCutoff = moment($stateParams.date).endOf(this.dateViewToggle).format()
      this.isToday = moment(this.dateCutoff).isSame(this.now, 'day')
      this.todaysDate = $stateParams.date
    } else {
      this.isToday = true
      this.dateCutoff = moment(this.now).startOf(this.dateViewToggle).format()
      this.futureDateCutoff = moment(this.now).endOf(this.dateViewToggle).format()
    }

    this.jobTypes = jobTypes
    this.startDateOfWeek = moment().toDate()
    this.selectedDay
    this.allSelect = false
    this.anySelect = false

    this.region
    this.acctManager
    this.acctManagerName
    this.cancelledJobs = false
    this.regions = []
    this.acctManagers = admins
    this.amList = this.acctManagers.map(am => am.id)

    this.sortBy = 'title'
    this.sortReverse = false

    this.groupByKey = 'company'
    this.hideDirectHire = false
    this.showOnlyDirectHire = false
    this.hideEndedJobs = true
    this.sortStartTime = false
    this.Auth = Auth

    this.selectedCity

    this.usersLoader = false

    this.query = { updateUsers: [] }
    this.expanded = {}

    /* will be eventially moved to DB */
    this.nationalAccountCondition = CONFIG.IS_PROD
    ? {
      parent_company_ids: [653, 664, 22],
      name_starts_with: ['bonappetit', 'lyft', 'grove']
    }
    // staging accounts designated National for testing
    : {
      parent_company_ids: [653, 2],
      name_starts_with: ['national']
    }

    ReferenceService.getRegions()
    .then(results => {
      this.regions = sort((a, b) => { return a.label > b.label ? 1 : -1 }, results)
      this.regions.unshift({label: DEFAULT_REGIONS_OPTION})
      this.Auth.getDetails()
      .then(result => {
        // default to all regions if user region is not set
        this.region = result.region_id == null
          ? DEFAULT_REGIONS_OPTION
          : find(propEq('id', result.region_id))(this.regions).label
        
        if (this.amList.includes(result.internalId)) {
          this.acctManager = result.internalId
        }
        this.getJobs(this.startDateOfWeek)
      })
    })

    this.getFeatureFlags()
  }

  setAcctManager () {
    if (typeof this.acctManager === 'undefined' || this.acctManager == null) {
      this.acctManagerName = 'All users';
    }
    else if (this.acctManager == 'Unassigned') {
      this.acctManagerName = find(propEq('id', this.acctManager))(this.acctManagers).first_name;
    }
    else {
      const firstName = find(propEq('id', this.acctManager))(this.acctManagers).first_name;
      const lastName = find(propEq('id', this.acctManager))(this.acctManagers).last_name;
      this.acctManagerName = `${firstName} ${lastName}`
    }
  }

  getJobs (day = moment()) {
    this.loaded = false
    this.ToastService.showLoader()
    this.startDateOfWeek = day
    this.selectedDay = day
    let startDateOfWeek = moment(this.startDateOfWeek)
    let queryDate = startDateOfWeek.startOf('day').toDate()

    let region = this.region === DEFAULT_REGIONS_OPTION ? null : this.region
    this.ManageJobs.getManagedJobs(queryDate, region, false, this.cancelledJobs, this.acctManager, this.acctManagers)
      .then(data => {
        for (let jobId in data) {
          data[jobId].nationalAccount = this.isNationalAccount(data[jobId])
        }
        this.jobsForWeek = data
        this.group(this.jobsForWeek)
        if (this.openJobId) {
          // if you pass in Job Id Url Param, Open the job that was passed in
          let openPanel = find(propEq('job_id', parseInt(this.openJobId)))(data)
          if (openPanel) {
            this.openByCompany(openPanel.company_name)
          } else {
            this.ToastService.showWarning('Job not found.')
          }
        }
        this.loaded = true
        this.ToastService.hideLoader()
      })
      .catch((error) => {
        console.log(error)
        return this.ToastService.showWarning('Unable to load jobs.')
      })
  }

  getLocalTimestamp (dateUTC) {
    return new Date(dateUTC).toLocaleString();
  }

  getStartOfWeekString (dateUTC) {
    return moment(dateUTC).startOf('isoWeek').format('dddd MMMM Do, YYYY')
  }

  interpolationChecker (value) {
    return Number.isNaN(value)
  }

  // HELPER - returns array containing external ids for a group of jobs
  getGroupExternalIds (group) {
    return group?.jobs?.map(job => job.external_id) || [];
  }

  /*
  * conditionally appends the number of unique dispatch views and timestamps to each job in the selected group
  * conditionally generates tooltip language for display on hover
  */
  async getJobsSentReadCount (group) {
    const reqBody = this.getGroupExternalIds(group);
    let setCount = 0;
    if(reqBody.length) {
      let sentCount = await this.ManageJobs.getJobsSentReadCount(reqBody);
    }
    for (let job in group.jobs) {
      if(sentCount[group.jobs[job].external_id].status === 'unviewed') {
        group.jobs[job].last_segment_update = new Date(sentCount[group.jobs[job].external_id].lastUpdate).toLocaleString();
        group.jobs[job].last_viewed = sentCount[group.jobs[job].external_id].lastViewed;
        group.jobs[job].data_pulled = new Date(sentCount[group.jobs[job].external_id].dataPulled).toLocaleString();
      }
      else if(sentCount[group.jobs[job].external_id].status === 'viewed' ) {
        group.jobs[job].last_segment_update = new Date(sentCount[group.jobs[job].external_id].lastupdate).toLocaleString();
        group.jobs[job].last_viewed = new Date(sentCount[group.jobs[job].external_id].lastViewed).toLocaleString();
        group.jobs[job].data_pulled = new Date(sentCount[group.jobs[job].external_id].dataPulled).toLocaleString();
      }
      else {
        group.jobs[job].last_segment_update = '?';
        group.jobs[job].last_viewed = '?';
        group.jobs[job].data_pulled = new Date(sentCount[group.jobs[job].external_id].dataPulled).toLocaleString();
      }
    }
  }

  onGroupExpand (group) {
    if (!this.expanded[group.title]) {
      if (this.groupByKey == 'company') {
        // first get the company_id for one of the jobs, we can be sure that the internal_id should be
        // the same for all of the jobs
        const companyId = group.groupedJobs[0].jobs[0].company_internal_id;
        this.ManageJobs.getManagedJobsByCompanyId(companyId, false)
          .then(data => {
            const newJobs = [];
            for (let jobId in data) {
              data[jobId].nationalAccount = this.isNationalAccount(data[jobId])
              newJobs.push(data[jobId])
            }
            group.groupedJobs[0].jobs = newJobs;
            this.group(this.jobsForWeek)

          }).then(() => {
            this.expanded[group.title] = true;
            this.getJobsSentReadCount(group);
          })
      } else {
        this.expanded[group.title] = true;
        this.getJobsSentReadCount(group);
      }
    } else {
      this.expanded[group.title] = false;
    }
  }

  updateFilter (day = moment()) {
    this.startDateOfWeek = day
    this.selectedDay = day
    let startDateOfWeek = moment(this.startDateOfWeek)
    let queryDate = startDateOfWeek.startOf('day').toDate()

    this.ManageJobs.getManagedJobs(queryDate, this.region, false, this.cancelledJobs, this.accountManager)
      .then(data => {
        this.jobsForWeek = data
        this.group(this.jobsForWeek, false)
      })
      .catch((error) => {
        console.log(error)
        return this.ToastService.showWarning('Unable to load jobs.')
      })
  }

  calculateFillForJobs (allJobs) {
    //  filter out future start date jobs for weekly stats
    const jobs = filter(job => !this.dateIsAfterThisSunday(job.start_date_time), allJobs)
    const numberOfJobs = jobs.length
    const totalNeeded = reduce((a, b) => a + b.needed, 0, jobs)
    const totalOnJob = reduce((a, b) => a + b.pplOnJob || 0, 0, jobs)
    const weeklyRevenue = reduce((a, b) => a + b.weekly_revenue, 0, jobs)
    const weeklyRevenueOpp = reduce((a, b) => a + b.total_wages_opportunity, 0, jobs)
    const unfilledJobs = reduce((a, b) => b.pplOnJob >= b.needed ? a + 1 : a, 0, jobs)
    const avgWage = (reduce((a, b) => a + b.wage, 0, jobs) / numberOfJobs).toPrecision(4)

    const futureJobs = filter(job => this.dateIsAfterThisSunday(job.start_date_time), allJobs)
    const numberOfFutureJobs = futureJobs.length
    const totalFutureNeeded = reduce((a, b) => a + b.needed, 0, futureJobs)
    const totalOnFutureJob = reduce((a, b) => a + b.pplOnJob || 0, 0, futureJobs)
    const weeklyFutureRevenue = reduce((a, b) => a + b.weekly_revenue, 0, futureJobs)
    const weeklyFutureRevenueOpp = reduce((a, b) => a + b.total_wages_opportunity, 0, futureJobs)
    const unfilledFutureJobs = reduce((a, b) => b.pplOnJob >= b.needed ? a + 1 : a, 0, futureJobs)
    const avgFutureWage = (reduce((a, b) => a + b.wage, 0, futureJobs) / numberOfFutureJobs).toPrecision(4)


    let fillRate = Math.floor(totalOnJob / totalNeeded * 100)
    let futureFillRate = Math.floor(totalOnFutureJob / totalFutureNeeded * 100)

    return {totalOnJob, totalNeeded, fillRate, unfilledJobs, numberOfJobs, weeklyRevenue, weeklyRevenueOpp, avgWage,
      futureJobs, numberOfFutureJobs, totalFutureNeeded, totalOnFutureJob, weeklyFutureRevenue, weeklyFutureRevenueOpp,
      unfilledFutureJobs, futureFillRate, avgFutureWage}
  }

  jobIsValid (job) {
    if (!job.attachedUsers && !job.invited_worker && !job.directHires) return false
    return true
  }

  filterByRegion () {
    const jobs = this.region === DEFAULT_REGIONS_OPTION ? this.jobsForWeek : filter(x => x.region == this.region, this.jobsForWeek)
    this.group(jobs)
  }

  applyFilters() {
    this.getJobs(this.startDateOfWeek);
  }

  group (jobs, collapse = true) {
    if (collapse) {
      this.expanded = {}
    }

    let clonedJobs = clone(jobs)

    const groupByRegion = (job) => {
      return job.region
    }

    const groupByCompany = (job) => {
      return job.company_name
    }

    const groupByPosition = (job) => {
      return job.title
    }

    const jobsGroupedByPosition = pipe(
        groupBy(groupByPosition),
        mapObjIndexed((jobs, title) => {
          return { title, jobs: jobs }
        }),
        values
    );

    const groupByType = (job) => {
      let index = findIndex(x => x.id === job.job_type, this.jobTypes)
      if (index > -1) {
        return this.jobTypes[index].name
      }
    }

    const groupByDefault = (job) => {
      return 'All Jobs'
    }

    let groupByFunction

    switch (this.groupByKey) {
      case 'region':
        groupByFunction = pipe(
          groupBy(groupByRegion),
          mapObjIndexed((jobs, region) => {
            const groupedJobs = jobsGroupedByPosition(jobs);
            let fill = this.calculateFillForJobs(jobs)
            return { title: region, fill, groupedJobs }
          }),
          values
        )
        break
      case 'company':
        groupByFunction = pipe(
          groupBy(groupByCompany),
          mapObjIndexed((jobs, company) => {
            let fill = this.calculateFillForJobs(jobs)
            const groupedJobs = jobsGroupedByPosition(jobs);
            return { title: company, fill, groupedJobs }
          }),
          values
        )
        break
      case 'job_type':
        groupByFunction = pipe(
          groupBy(groupByType),
          mapObjIndexed((jobs, type) => {
            let fill = this.calculateFillForJobs(jobs)
            const groupedJobs = jobsGroupedByPosition(jobs);
            return { title: type, fill, groupedJobs }
          }),
          values
        )
        break
      default:
        groupByFunction = groupBy(groupByDefault)
    }

    if (this.hideDirectHire) {
      clonedJobs = filter(job => !job.is_direct_hire, clonedJobs)
    }

    if (this.showOnlyDirectHire) {
      clonedJobs = filter(job => job.is_direct_hire, clonedJobs)
    }

    if (this.hideEndedJobs) {
      clonedJobs = filter(job => moment(job.end_date_time).diff(moment(this.selectedDay)) >= 0, clonedJobs)
    }

    if (this.nationalAccountsOnly) {
      clonedJobs = filter(job => job.nationalAccount, clonedJobs)
    }

    if (this.implementationMode) {
      clonedJobs = filter(job => job.company_in_implementation_mode, clonedJobs)
    }

    if (this.searchCompanyText) {
      clonedJobs = filter(job => job.company_name.toLowerCase().includes(this.searchCompanyText.toLowerCase()), clonedJobs)
    }

    if (this.searchJobId) {
      clonedJobs = filter(job => job.job_id.toString().includes(this.searchJobId), clonedJobs)
    }

    // added int parsing to handle interaction values passed from new AM filter 4/14/2022
    if (this.acctManager) {
      clonedJobs = filter(job => job.am_id === parseInt(this.acctManager), clonedJobs)
    }

    this.today = moment(this.selectedDay).toDate()

    if (this.sortStartTime) {
      this.totalStats = this.calculateFillForJobs(clonedJobs)
      const today = new Date()
      const startsTodayJobs = []
      const startsTomorrowJobs = []
      const startsThisWeekJobs = []
      const futureStartsJobs = []
      const ongoingJobs = []

      clonedJobs.forEach(job => {
        const differenceInDays = differenceInCalendarDays(job.start_date_time, today)

        if (this.dateIsAfterThisSunday(job.start_date_time)) {
          futureStartsJobs.push(job)
        } else if (differenceInDays < 0) {
          ongoingJobs.push(job)
        } else if (differenceInDays === 0) {
          startsTodayJobs.push(job)
        } else if (differenceInDays === 1) {
          startsTomorrowJobs.push(job)
        } else {
          startsThisWeekJobs.push(job)
        }
      })
      this.groupedJobs = {
        startsToday: groupByFunction(startsTodayJobs),
        startsTomorrow: groupByFunction(startsTomorrowJobs),
        startsThisWeek: groupByFunction(startsThisWeekJobs),
        futureStarts: groupByFunction(futureStartsJobs),
        ongoing: groupByFunction(ongoingJobs)}
    } else {
      let virtualizedJobs = this.virtualize(clonedJobs)
      let allJobs = groupByFunction(virtualizedJobs)
      this.totalStats = this.calculateFillForJobs(virtualizedJobs)
      this.groupedJobs = {allJobs}
    }

    if (this.searchJobId && clonedJobs.length === 1) {
      this.expanded[this.groupedJobs.allJobs[0].title] = true
    }
  }

  virtualize(jobs) {
    let nonVirtualJobs = jobs.filter((job) => job.virtual_job_id == null)
    let virtualJobs = jobs.filter((job) => job.virtual_job_id != null)

    let virtualizedJobs = []
    if(virtualJobs.length > 0) {
      let virtualJobGroup = groupBy((job) => job.virtual_job_id, virtualJobs)
      let virtualized = Object.keys(virtualJobGroup).map((virtual_job_id) => this.virtualizeJob(virtualJobGroup[virtual_job_id], virtual_job_id)).filter((job) => job != undefined)
      virtualizedJobs.push(...virtualized)
    }

    let allJobs = []
    allJobs.push(...nonVirtualJobs)
    allJobs.push(...virtualizedJobs)
    allJobs.sort((a, b) => a.job_id - b.job_id)
    return allJobs
  }

  virtualizeJob(jobs, virtualJobId) {
    // get latest_job_id and return unique latest_fragment
    let lastestFragmentIds = jobs.map((job) => job.latest_job_id).filter((v, i, a) => a.indexOf(v) === i)

    // latest_fragment is not unique there is some data issue with this job
    if(lastestFragmentIds.length > 1) {
      console.error("VirtualWorkRequest contain multiple latest job fragments can not reconcile virtual_job_id=" + virtualJobId + " latest_fragments=" + lastestFragmentIds)
      return;
    }
    let latestFragmentId = lastestFragmentIds[0]
    let pplOnJob = jobs.map((job) => job.pplOnJob).reduce((a, b) => a + b, 0)
    let needed = jobs.map((job) => job.needed).reduce((a, b) => a + b, 0)
    let weeklyRevenue = jobs.map((job) => job.weekly_revenue).reduce((a, b) => a + b, 0)

    let latestFragments = jobs.filter((job) => job.job_id == latestFragmentId)

    if(latestFragments.length != 1) {
      console.error("Cannot find the latest fragment virtual_job_id=" + virtualJobId + " latest_fragment_id=" + latestFragmentId)
      return;
    }
    let latestFragment = clone(latestFragments[0])

    // needed should only be on the latest fragment - other fragments should be 0
    if(latestFragment.needed != needed) {
      console.error("Needed dectect on non-latest fragment needed=" + needed + " virtual_job_id=" + virtualJobId + " latest_fragment_id=" + latestFragmentId)
      return;
    }

    latestFragment.job_id = Number(virtualJobId)
    latestFragment.pplOnJob = pplOnJob
    latestFragment.weekly_revenue = weeklyRevenue

    return latestFragment
  }

  isEmpty (obj) {
    return isEmpty(obj)
  }

  /**
   * Determines if a job belongs to a national account based on parent company ID
   * or company name patterns defined in nationalAccountCondition.
   * Does not mutate the job object.
   * @param {Object} job - Job object with company_name and parent_company_id properties
   * @returns {boolean} - True if job is from a national account, false otherwise
   */
  isNationalAccount(job) {
    if (!job || !job.company_name) {
      return false
    }

    const companyNormalizedName = job.company_name.toLowerCase().replace(/\s+/g, '')

    if (this.nationalAccountCondition.parent_company_ids.includes(job.parent_company_id)) {
      return true
    }

    return this.nationalAccountCondition.name_starts_with.some(text =>
      companyNormalizedName.startsWith(text)
    )
  }

  showUpdateWage ($event, job) {
    /**
     * Phoenix-enabled workplaces have limited Manage Jobs functionality.  In this case: wages cannot be edited.
     */
    if (this.isPhoenix(job)) {
      return this.ToastService.showWarning('Cannot change wages for work requests from Phoenix workplace ' + job.company_name + '.' +
          ' To manually change a wage for a work request or assignment - use Phoenix.')
    }
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: updateWageModal,
      fullscreen: true,
      clickOutsideToClose: true,
      locals: {
        jobId: job.job_id,
        wage: job.wage
      },
      controller: updateWageModalController,
      controllerAs: 'uw'
    }).then((jobs) => {
      if(!jobs) return
      this.jobsForWeek = jobs
      this.group(this.jobsForWeek, false)
      return this.ToastService.showSuccess('Successfully Updated Wage.')
    })
  }

  showRosterOptions ($event, job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      clickOutsideToClose: true,
      template: rosterOptions,

      controllerAs: 'ro',
      locals: { job, selectedDay: this.selectedDay },
      controller: class rosterOptionsCtrl {
        /* @ngInject*/
        constructor (ManageJobs, job, selectedDay, ToastService, $window) {
          this.ManageJobs = ManageJobs
          this.job = job
          this.selectedDay = selectedDay
          this.ToastService = ToastService
          this.$window = $window
        }

        downloadRosterCSV (job) {
          return this.ManageJobs.getRosterCSV(job)
            .then((res) => {
              let file = new Blob([res.data], {type: 'application/csv'})
              let fileName = job.company_name.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, '-') + '-' + moment(job.start_date_time).format('YYYY-MM-DD')
              let fileURL = URL.createObjectURL(file)

              let a = document.createElement('a')
              a.href = fileURL
              a.target = '_blank'
              a.download = fileName + '.csv'
              document.body.appendChild(a)
              a.click()
            })
            .catch(() => {
              return this.ToastService.showWarning('Roster Not Available')
            })
        }

        downloadRosterPDF (day, job) {
          return this.ManageJobs.getRosterPDF(day, job)
            .then((res) => {
              let file = new Blob([res.data], {type: 'application/pdf'})
              let fileName = job.company_name.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, '-') + '-' + moment(job.start_date_time).format('YYYY-MM-DD')
              let fileURL = URL.createObjectURL(file)

              let a = document.createElement('a')
              a.href = fileURL
              a.target = '_blank'
              a.download = fileName + '.pdf'
              document.body.appendChild(a)
              a.click()
            })
            .catch(() => {
              return this.ToastService.showWarning('Roster Not Available')
            })
        }
      }
    })
  }

  showJobTimeline ($event, jobId) {
    this.ManageJobs.getJobTimeline({ jobId: jobId })
    .then(res => {
      let users = keys(res)
      let str = ''
      for (var j = 0; j < users.length; j++) {
        str += '<tr>'
        str += '<td>' + res[users[j]].name + '</td>'
        str += '<td>' + res[users[j]].applied_at + '</td>'
        str += '<td>' + res[users[j]].application_last_updated + '</td>'
        str += '<td>' + res[users[j]].application_status + '</td>'
        str += '<td>' + res[users[j]].confirm_time + '</td>'
        str += '<td>' + res[users[j]].confirm_status + '</td>'
        str += '<td>' + res[users[j]].confirm_updated_at + '</td>'
        str += '<td>' + res[users[j]].added_from_waitlist_time + '</td>'
        str += '<td>' + res[users[j]].added_from_waitlist_updated + '</td>'
        str += '<td>' + res[users[j]].waitlist_status + '</td>'
        str += '<td>' + res[users[j]].cancel_time + '</td>'
        str += '</tr>'
      }
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .multiple(true)
          .title('Job Accept Timeline')
          .htmlContent(`There are <strong> ${users.length}</strong> job accept / confirm / waitlist events <br>
          <table class="simple" cellpadding="0" cellspacing="0" border="0">
            <thead>
              <tr>
                <th style="text-align:left">User</th>
                <th style="text-align:left">Applied</th>
                <th style="text-align:left">Last Updated</th>
                <th style="text-align:left">Status</th>
                <th style="text-align:left">Confirm</th>
                <th style="text-align:left">Confirm Sent</th>
                <th style="text-align:left">Confirm Updated</th>
                <th style="text-align:left">Pull Waitlist</th>
                <th style="text-align:left">Waitlist Status</th>
                <th style="text-align:left">Waitlist Respone</th>
                <th style="text-align:left">Cancel</th>
              </tr>
            </thead>
            <tbody>
              ${str}
              </tbody>
          </table>
          `)
          .ariaLabel('User Info')
          .ok('Close')
      )
    })
  }

  showEditSchedule (job, selectedShift) {
    let confirm = {
      controller: editScheduleCtrl,
      controllerAs: 'add',
      template: editScheduleTpl,
      fullscreen: true,
      scope: this.$scope,
      preserveScope: true,
      clickOutsideToClose: true,
      locals: {
        company: this.company,
        jobs: this.jobs,
        dates: this.shifts,
        //  remove
        job: job,
        Users: this.Users,
        shift: selectedShift,
        workforce: this.myWorkforce
      }
    }
    return this.$mdDialog.show(confirm)
      .then()
      .finally(() => {
        confirm = undefined
        return this.$mdDialog.hide()
      })
  }

  _gethandleManageDetailsModalSuccess = (job) => {
    return ({message, jobDetails}) => {
      if (!jobDetails) {
        return this.ToastService.showWarning(message)
      }
      let index = findIndex(x => x.job_id === job.job_id, this.jobsForWeek)
      this.jobsForWeek[index] = {
        ...this.jobsForWeek[index],
        ...jobDetails
      }
      // for loops here because we want to modify the model job in place and break out of the loop since this
      // is a really deeply nested grouped array of grouped arrays
      let updated = false;
      for(let i = 0, groupedJobsLength = this.groupedJobs.allJobs.length; i < groupedJobsLength; i++) {
        const groupedChildJobs = this.groupedJobs.allJobs[i];
        for(let j = 0, groupedChildJobsLength = groupedChildJobs.groupedJobs.length; j < groupedChildJobsLength; j++ ) {
          const gcj = groupedChildJobs.groupedJobs[j];
          for(let k = 0, gcjLength = gcj.jobs.length; k < gcjLength; k++) {
            let cj = gcj.jobs[k];
            if(cj.job_id === jobDetails.job_id) {
              gcj.jobs[k] = {
                ...cj,
                ...jobDetails
              };
              updated = true;
              break;
            }
          }
          if(updated) {
            break;
          }
        }
        if(updated) {
          break;
        }
      }

      return this.ToastService.showSuccess(message)
    }
  }
  _handleManageDetailsModalRejection = () => {
    return this.ToastService.showSuccess('No Changes Made')
  }

  showManageDetails ($event, job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: manageDetails,
      locals: {
        job: job,
        manageJobs: this.ManageJobs,
        supervisors: this.Companies.fetchCompanyUsers(job.company_id)
      },
      controller: manageDetailsController,
      controllerAs: 'md',
      onRemoving: () => {
        this.$templateCache.remove(manageDetails)
      }
    }).then(
      this._gethandleManageDetailsModalSuccess(job),
      this._handleManageDetailsModalRejection
    )
  }

  showManageReqs ($event, job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: manageReqs,
      fullscreen: true,
      clickOutsideToClose: true,
      locals: {
        jobId: job.job_id,
        reqs: job.requirements,
        updateReqs: this.ManageJobs.updateReqs
      },
      controller: manageReqsController,
      controllerAs: 'mr'
    })
  }

  wholePlatform (job) {
    this.ManageJobs.wholePlatform({ jobId: job.external_id, wholePlatform: true })
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, { whole_platform: 1 })
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to increase speed.')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(this.jobsForWeek, false)
        return this.ToastService.showSuccess('Successfully sent to whole platform.')
      })
  }

  updateNeededAndOverfill (job, needed, overfill) {
    if (job.needed !== needed && needed >= 0) this.updateNumberNeeded(job, needed)
    if (job.overfill !== overfill && overfill >= 0) this.updateOverfill(job, overfill)
  }

  updateNumberNeeded (job, newNumberNeeded) {
    this.ManageJobs.updateNumberNeeded(
      {
        jobId: job.external_id,
        needed: newNumberNeeded,
        prevNeeded: job.needed
      })
      .then(() => {
        return this.ManageJobs.setJobVal(job.latest_job_id || job.job_id, { needed: newNumberNeeded })
          .then((jobs) => {
            this.jobsForWeek = jobs
            this.group(this.jobsForWeek, false)
            return this.ToastService.showSuccess('Successfully updated number needed')
          })
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to update Number Needed.')
      })
  }

  updateOverfill (job, overfill) {
    this.ManageJobs.updateOverfill(
      {
        jobId: job.external_id,
        overfill: overfill,
        prevOverfill: job.overfill
      })
      .then(() => {
        return this.ManageJobs.setJobVal(job.latest_job_id || job.job_id, { overfill: overfill })
          .then((jobs) => {
            this.jobsForWeek = jobs
            this.group(this.jobsForWeek, false)
            return this.ToastService.showSuccess('Successfully updated overfill')
          })
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to update Number Needed.')
      })
  }

  cancelJob (job) {
    const confirm = this.$mdDialog.confirm()
        .title('Cancel Job')
        .textContent('Are you sure you want to cancel?')
        .ariaLabel('Cancel Job')
        .ok('Yes')
        .cancel('No')
    this.$mdDialog.show(confirm)
        .then(() => {
          this.ManageJobs.cancelJob({ jobId: job.external_id})
              .then(() => {
                const jobs = this.ManageJobs.deleteJob(job.job_id)
                this.group(jobs, false)
                this.ToastService.showSuccess('Successfully canceled job.')
              })
              .catch(() => {
                this.ToastService.showWarning('Unable to cancel job.')
              })
        }, () => {})
  }

  showActionConfirm (callKey, data, successMessage = 'Action Successful', errMessage = 'Action Failed') {
    if (!callKey || !data) return

    this.ManageJobs[callKey](data)
      .then(() => this.ToastService.showSuccess(successMessage),
      () => this.ToastService.showWarning(errMessage))
  }

  toggleJobReminder (job) {
    let reminders = !job.reminders ? 1 : 0
    let data = { jobId: job.external_id, reminder: !job.reminders }
    this.ManageJobs.updateReminders(data)
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, 'reminders', reminders)
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to Modify Job Status')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(jobs, false)
        return this.ToastService.showSuccess('Successfully Toggled Job Reminders')
      })
  }

    /**
   * todo - split out this method into two parts
   * 1) wrapper for toggling job pause status
   * 2) generalized method for getting, filtering, and grouping jobs after a property is updated
   */
  pauseJob (job) {
    let pause = !job.paused
    let data = { jobId: job.external_id, pause }
    this.ManageJobs.pauseJob(data)
      .then(() => {
        return this.ManageJobs.setJobVal(job.latest_job_id || job.job_id, {paused: pause})
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to Modify Job Status')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(this.jobsForWeek, false)
        return this.ToastService.showSuccess('Toggled Job Pause Status')
      })
  }

  startNickAlgo (job) {
    this.ManageJobs.startNickAlgo({jobId: job.external_id})
      .then((res) => {
        this.$mdDialog.show(
          this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Job Dispatch')
            .content(res.data)
            .ariaLabel('Start Dispatch')
            .ok('Close')
        )
        // let currentlyFilling = !job.currentlyFilling
      })
      .catch((error) => {
        this.$mdDialog.show(
          this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Job Dispatch')
            .content(error.data)
            .ariaLabel('Start Dispatch Error')
            .ok('Close')
        )
      })
  }

  confirmRosterChanges (job) {

    /**
     * Phoenix-enabled workplaces have limited Manage Jobs functionality.  In this case: assignments cannot be edited.
     */
    if (this.isPhoenix(job)) {
      return this.ToastService.showWarning('Cannot change roster for Phoenix workplace ' + job.company_name + '.' +
          ' To manually take a CM off a job - use Phoenix to cancel their assignment.' +
          ' To manually put a CM on a job - use Admin Tools -> View Profile -> Select a Crew Member -> Admin -> Put On Job')
    }

    const jobStatuses = {
      'success': 0,
      'waitlist': 1,
      'removed': 8
    }
    const blockedWorkers = []
    const shouldCheckTestingStatus = new Date(job.start_date_time) < new Date(new Date().getTime() + this.getDaysToMilliseconds(1))

    mapObjIndexed((workersInBucket, statusName) => {
      forEach(worker => {
        const status = jobStatuses[statusName]
        if (status === 0 && job.covid_policy) {
          switch (job.covid_policy) {
            case 'VACCINE_OR_EXEMPTION':
              if (!this.isWorkerVaccinated(worker) && !worker.covid_exemption_approved_date) {
                blockedWorkers.push(worker.first_name + ' ' + worker.last_name)
              }
              break;
            case 'VACCINE_OR_WEEKLY_TESTING':
              if (!this.isWorkerVaccinated(worker) && shouldCheckTestingStatus && (!worker.covid_testing_latest_date
              || !this.isCovidTestValidForJobStartDate(worker, job))) {
                blockedWorkers.push(worker.first_name + ' ' + worker.last_name)
              }
              break;
            case 'VACCINE_OR_EXEMPTION_AND_WEEKLY_TESTING':
              if (!this.isWorkerVaccinated(worker) && shouldCheckTestingStatus && (!worker.covid_exemption_approved_date
              || !worker.covid_testing_latest_date || !this.isCovidTestValidForJobStartDate(worker, job))) {
                blockedWorkers.push(worker.first_name + ' ' + worker.last_name)
              }
              break;
            default:
              break;
          }
        }
        if (worker.status !== status) {
          worker.status = status
          this.query.updateUsers.push({
            status: status,
            jobId: job.external_id,
            userId: worker.external_id
          })
        }
      }, workersInBucket)
    }, {success: this.success, waitlist: this.waitlist, removed: this.removed})

    if (blockedWorkers.length > 0) {
      const workersStr = blockedWorkers.join(', ') + '.'
      return this.ToastService.showWarning('The following CM cannot be assigned: ' + workersStr
      + ' Their vaccination or exemption status do not comply with the company\'s policies.');
    }

    if (this.query.updateUsers.length === 0) {
      return this.ToastService.showWarning('No Workers Changed. Please Change Worker Status to Continue!')
    }

    const confirm = this.$mdDialog.confirm({
      title: 'Change Worker Roster',
      ok: 'Submit',
      cancel: 'Cancel'
    })

    return this.$mdDialog.show(confirm)
      .then(() => {
        const removedCMs = this.query.updateUsers
          .filter(u => u.status === ROSTER_STATUS.REMOVED)
          .map(u => this.removed.find(w => w.external_id === u.userId))
          .filter(worker => {
            if (!worker) debug('Worker not found in removed array during roster update')
            return !!worker
          })
          .map(worker => `${worker.first_name} ${worker.last_name}`)
        
        return this.ManageJobs.updateJob(this.query)
          .then(() => this.Jobs.getJobAttachedUsers([job.external_id]))
          .then(updatedUsers => {
            this.query.updateUsers = []
            let changedRoster = updatedUsers[job.job_id]
            
            return this.ManageJobs.setJobVal(job.job_id, changedRoster)
            .then((jobs) => {
              const companyToKeepExpanded = job.company_name
              
              let startDateOfWeek = moment(this.startDateOfWeek)
              let queryDate = startDateOfWeek.startOf('day').toDate()
              let region = this.region === 'All regions' ? null : this.region
              
              return this.ManageJobs.getManagedJobs(queryDate, region, false, this.cancelledJobs, this.acctManager, this.acctManagers)
                .then(data => {
                  for (let jobId in data) {
                    data[jobId].nationalAccount = this.isNationalAccount(data[jobId])
                  }
                  this.jobsForWeek = data
                  
                  this.group(this.jobsForWeek, false)
                  
                  if (companyToKeepExpanded) {
                    this.expanded[companyToKeepExpanded] = true
                  }
                  
                  if (removedCMs.length > 0) {
                    const cmNames = removedCMs.join(', ')
                    this.ToastService.showSuccess(`${cmNames} removed from job ${job.external_id}`, 'top center')
                  }
                  
                  this.ToastService.showSuccess('Worker Roster Updated.', 'bottom center')

                  return this.$mdDialog.hide()
                })
            })
          })
      })
      .catch((err) => {
        if (err && err.status === 409) {
          return this.handleOverlap(err)
        } else if (err && err.status) {
          this.$mdDialog.hide()
          return this.ToastService.showWarning('Failed to update roster. Please try again.')
        } else {
          this.$mdDialog.hide()
          return this.ToastService.showWarning('Canceled roster update.')
        }
      })
  }

  /**
   * Handles job overlap error by showing a modal with conflicting users
   * @param error - error response from server
   * @returns {*} - promise resolved when modal is closed
   */
  handleOverlap (error) {
      const confirm = {
      parent: document.body,
      multiple: true,
      fullscreen: true,
      template: jobOverlapModal,
      controller: JobOverlapModalController,
      ariaLabel: 'Job overlap',
      controllerAs: 'e',
      locals: {
        message: `${(this.getUsersNames(error))} has a conflicting schedule & cant be added to this job.`,
      },
    }
    return this.$mdDialog.show(confirm)
  }

  /**
   * Extracts Names from error response
   * @param error - error response from server
   * @returns {*|string|string} - comma-delimited string of names or "User(s)" if no names found
   */
  getUsersNames(error) {
      const reason = error.data?.reason;
      const user = "User(s)";
      if (!reason) return user;
      try {
          let parsed;
          if (Array.isArray(reason)) {
              parsed = reason;
          }
          if (typeof reason === 'string') {
              parsed = JSON.parse(reason);
          }
          if (typeof reason === 'object' && !Array.isArray(reason)) {
              parsed = [reason];
          }
          if (!parsed) {
              parsed = [];
          }
          return parsed.length ? pluck('name', parsed).join(', ') : user;
      } catch {
          return user;
      }
  }

  isWorkerVaccinated(worker) {
    return worker.covid_vaccination_response === 'YES' || worker.covid_vaccination_date !== null
  }

  isCovidTestValidForJobStartDate(worker, job) {
    return new Date(job.start_date_time).setUTCHours(0, 0, 0, 0) <= this.addDays(worker.covid_testing_latest_date, 7).setUTCHours(0, 0, 0, 0)
  }

  addDays(date, days) {
    var result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
  }

  getDaysToMilliseconds(days) {
    return (days * 24 * 60 * 60 * 1000)
  }

  /**
   * Returns {@code true} if the specified job is owned by a workplace with Phoenix enabled.
   *
   * Phoenix-enabled workplaces have limited Manage Jobs functionality.  For example, assignments cannot be edited.
   */
  isPhoenix (job) {
    const attributes = { company_id: job.company_internal_id, company_name: job.company_name }
    const isPhoenix = false
    return isPhoenix
  }

  // Manage workers expansion panels
  showManageWorkers (job) {
    // const enums = {
    //   0: 'success',
    //   1: 'waitlist',
    //   8: 'removed'
    // }

    this.usersLoader = true
    // this.$mdExpansionPanel(parseInt(job.job_id)).expand()
    // this.$mdExpansionPanel().waitFor(this.openJobId).then(function (instance) {
    //   instance.expand()
    // })
    this.Jobs.getJobAttachedUsers([job.external_id])
      .then(workerList => {
        let workerData = head(values(workerList))
        this.getRoster(workerData.attachedUsers, job.job_id).then(roster => {
          this.roster = roster
          this.success = filter(worker => { return worker.status === ROSTER_STATUS.ASSIGNED }, this.roster) || []
          this.waitlist = filter(worker => { return worker.status === ROSTER_STATUS.WAITLIST }, this.roster) || []
          this.directHires = job.directHires || job.crewPost || []
          this.removed = filter(worker => { return worker.status === ROSTER_STATUS.REMOVED }, this.roster) || []
          this.selectedWorker
          this.note
          this.selected = null
          this.query = { updateUsers: [] }
          this.usersLoader = false
        })
      })
  }

  jobHasWorkers (job) {
    return job.attachedUsers || job.directHires || job.invited_worker_external_id
  }

  showReminderEmails (job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      // targetEvent: $event,
      clickOutsideToClose: true,
      template: reminderEmail,
      controllerAs: 're',
      multiple: true,
      locals: { job: this.job },
      controller: reminderEmailCtrl
    })
  }

  updateWorkerError (err) {
    if (!err) return
    this.ToastService.showWarning('Unable to update worker statuses.')
  }

  viewProfile (id) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: profileTemplate,
      clickOutsideToClose: true,
      scope: this.$scope,
      preserveScope: true,
      locals: {
        worker: this.Users.getProfile(id),
        notes: this.Users.getNotes(id),
        application: this.Users.fetchApplication(id),
        jobTypes: this.jobTypes,
        skills: this.Users.getSkills(id),
        company: this.company,
        inModal: true
      },
      fullscreen: true,
      controller: WorkerController,
      controllerAs: 'w',
      onRemoving: () => {
        this.$templateCache.remove(profileTemplate)
      }
    })
  }

  showGroupMessage ($event, users) {
    const parentEl = document.body
    let userIds = pluck('external_id', users)
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: groupMessage,
      locals: {
        users: userIds
      },
      controller: groupMessageController,
      controllerAs: 'gm'
    })
  }

  singleMessage ($event, workerId) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: groupMessage,
      locals: {
        users: [workerId]
      },
      controller: groupMessageController,
      controllerAs: 'gm'
    })
  }

  getAdminIntercom (adminEmail) {
    this.singleUserMessagesLoading = true
    this.Message.getAdminConversations(adminEmail)
    .then((conv) => {
      this.intercomMessages = conv.body.conversations
      this.singleUserMessagesLoading = false
    })
  }

  showAddWorker (job) {

    /**
     * Phoenix-enabled workplaces have limited Manage Jobs functionality.  In this case: assignments cannot be edited.
     */
    if (this.isPhoenix(job)) {
      return this.ToastService.showWarning('Cannot change roster for Phoenix workplace ' + job.company_name + '.' +
          ' To manually put a CM on a job - use Admin Tools -> View Profile -> Select a Crew Member -> Admin -> Put On Job')
    }

    let confirm = {
      controller: addWorkerCtrl,
      controllerAs: 'add',
      template: addWorkerTpl,
      fullscreen: true,
      clickOutsideToClose: true,
      locals: {
        Users: this.Users,
        job,
        shift: null
      }
    }

    return this.$mdDialog.show(confirm)
      .then(
        worker => {
          this.roster.push(worker)
          this.success.push(worker)
          this.$mdDialog.hide()
          return this.$mdToast.showSimple('Worker Roster Updated.')
        },
        () => {
          this.$mdDialog.hide()
          return this.$mdToast.showSimple('Cancelled Add Worker')
        }
      )
  }

  openByCompany (companyName) {
    this.expanded[companyName] = true
    // this.$mdExpansionPanel(parseInt(this.openJobId)).expand()
    this.$mdExpansionPanel().waitFor(this.openJobId).then(function (instance) {
      instance.expand()
    })
    this.openJobId = null
  }

  jobPulse (jobId) {
    this.Jobs.jobPulse(jobId)
    .then(res => {
      let users = keys(res)
      let numOverlapping = 0
      let str = ''
      for (var j = 0; j < users.length; j++) {
        var overlapping_company = ''
        if (res[users[j]].overlapping_company) { overlapping_company = res[users[j]].overlapping_company; numOverlapping++ }
        res[users[j]].overlapping_company
        str += '<tr>'
        str += '<td>' + res[users[j]].name + '</td>'
        str += '<td>' + res[users[j]].shifts_worked + '</td>'
        str += '<td>' + new Date(res[users[j]].last_shift).toDateString() + '</td>'
        str += '<td>' + res[users[j]].companies.toString() + '</td>'
        str += '<td>' + overlapping_company + '</td>'
      }
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .multiple(true)
          .title('Recently Active Workers')
          .htmlContent(`There are <strong> ${users.length}</strong> active users within 10 miles of this job in the past 15 days. <br>
          <strong>${numOverlapping}</strong> users are working other jobs <br>
          <table class="simple" cellpadding="0" cellspacing="0" border="0">
            <thead>
              <tr>
                <th style="text-align:left">Name</th>
                <th style="text-align:left">shifts worked</th>
                <th style="text-align:left">last shift</th>
                <th style="text-align:left">companies</th>
                <th style="text-align:left">overlaping</th>
              </tr>
            </thead>
            <tbody>
              ${str}
              </tbody>
          </table>
          `)
          .ariaLabel('User Info')
          .ok('Close')
      )
    })
  }

  dateIsAfterThisSunday (date) {
    const today = new Date()
    let thisSunday
    if (isSunday(today)) {
      thisSunday = today
    } else {
      const endOfWeekDate = endOfWeek(today)
      thisSunday = addDays(endOfWeekDate, 1)
    }

    return differenceInCalendarDays(date, thisSunday) > 0
  }

  getRoster (users, jobId) {
    return new Promise((resolve, reject) => {
      if (users.length === 0) {
        resolve(users)
        return
      }
      const userIds = users.map(user => user.id)
      Promise.all([
        this.Users.getPerformanceData(userIds),
        this.Users.getPerformanceScore(userIds, jobId)
      ]).then(result => {
        const roster = users.map(user => {
          return {
            ...user,
            ...result[0][user.id],
            ...result[1][user.id]
          }
        })
        resolve(roster)
      })
    })
  }

  getFeatureFlags () {
    this.Auth.splitClient.ready().then(() => {
      const reliabilityScoreKey = 'reliability_score'
      const overfillKey = 'Overfill-BCTOOLS-980'

      const treatments = this.Auth.splitClient.getTreatments([reliabilityScoreKey, overfillKey])

      this.showReliabilityScore = treatments[reliabilityScoreKey] === 'on'
      if (treatments[overfillKey] === 'edit') {
        this.showOverfill = true
        this.candEditOverfill = true
      } else if (treatments[overfillKey] === 'view') {
        this.showOverfill = true
        this.candEditOverfill = false
      } else {
        this.showOverfill = false
        this.candEditOverfill = false
      }
    }).catch(() => {
      console.log('Error Initializing Split.io')
    })
  }

  // BW-630
  isForkedJob(job) {
    return (!!job.forked_from)
  }
  
}

export default ManageJobsController
